<div class="d-flex flex-column w-100">
  <img [src]="img" [class.active]="active"/>
  <p class="fw-medium mt-25">{{ rol | titlecase }}</p>
</div>
